package org.zq.astrock_ai.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.remember
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import astockai2_master.app.shared.generated.resources.Res
import astockai2_master.app.shared.generated.resources.noto_sans_sc_black
import astockai2_master.app.shared.generated.resources.noto_sans_sc_bold
import astockai2_master.app.shared.generated.resources.noto_sans_sc_light
import astockai2_master.app.shared.generated.resources.noto_sans_sc_medium
import astockai2_master.app.shared.generated.resources.noto_sans_sc_regular
import org.jetbrains.compose.resources.Font

val LocalAppFontFamily = compositionLocalOf<FontFamily> { FontFamily.Default }

@Composable
fun rememberAppFontFamily(): FontFamily {
    val light = Font(Res.font.noto_sans_sc_light, weight = FontWeight.Light)
    val regular = Font(Res.font.noto_sans_sc_regular, weight = FontWeight.Normal)
    val medium = Font(Res.font.noto_sans_sc_medium, weight = FontWeight.Medium)
    // SemiBold 映射到 Medium 与 Bold 之间的最近可用字重
    val semiBold = Font(Res.font.noto_sans_sc_medium, weight = FontWeight.SemiBold)
    val bold = Font(Res.font.noto_sans_sc_bold, weight = FontWeight.Bold)
    val black = Font(Res.font.noto_sans_sc_black, weight = FontWeight.Black)
    return remember(light, regular, medium, semiBold, bold, black) {
        FontFamily(light, regular, medium, semiBold, bold, black)
    }
}

fun appTypography(
    fontFamily: FontFamily,
    base: Typography = Typography(),
): Typography = Typography(
    displayLarge = base.displayLarge.copy(fontFamily = fontFamily),
    displayMedium = base.displayMedium.copy(fontFamily = fontFamily),
    displaySmall = base.displaySmall.copy(fontFamily = fontFamily),
    headlineLarge = base.headlineLarge.copy(fontFamily = fontFamily),
    headlineMedium = base.headlineMedium.copy(fontFamily = fontFamily),
    headlineSmall = base.headlineSmall.copy(fontFamily = fontFamily),
    titleLarge = base.titleLarge.copy(fontFamily = fontFamily),
    titleMedium = base.titleMedium.copy(fontFamily = fontFamily),
    titleSmall = base.titleSmall.copy(fontFamily = fontFamily),
    bodyLarge = base.bodyLarge.copy(fontFamily = fontFamily),
    bodyMedium = base.bodyMedium.copy(fontFamily = fontFamily),
    bodySmall = base.bodySmall.copy(fontFamily = fontFamily),
    labelLarge = base.labelLarge.copy(fontFamily = fontFamily),
    labelMedium = base.labelMedium.copy(fontFamily = fontFamily),
    labelSmall = base.labelSmall.copy(fontFamily = fontFamily),
)

fun TextStyle.withAppFont(fontFamily: FontFamily): TextStyle =
    copy(fontFamily = fontFamily)
